
<template>
  <van-popup
    v-model="show"
    :overlay="false"
    z-index="2"
    position="bottom"
    :style="{ height: '100vh' }"
    :lock-scroll="false"
  >
    <div class="wrapper">
      <div class="block">
        <div class="button-close" @click="onCloseClick()">
          <img
            style="height: 19px"
            :src="require('../../../assets/imgs/icon/bottom-modal-close.png')"
          />
        </div>

        <div class="content-container">
          <div
            class="question-item-container"
            v-for="(item, index) in quizData.questions"
            :key="index"
          >
            <div class="question-item-index">{{ index + 1 }}.</div>
            <div class="question-item-title">
              <div>
                {{ item.title }}
              </div>
              <div
                class="question-option-select"
                v-if="answer[index] && answer[index].optionId"
                @click="onQuizSelect(index)"
              >
                {{ `已选${formatOptionLabel(index)}` }}
              </div>
              <div
                class="question-option-unselect"
                v-else
                @click="onQuizSelect(index)"
              >
                {{ `未选` }}
              </div>
            </div>
          </div>

          <div style="height: 50px; background-color: #fff"></div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import * as ActionTypes from "../../../store/action-types";
import ArticleContent from "../../../components/content/ArticleContent";
import { mapState } from "vuex";

export default {
  name: "QuizListModal",
  props: {
    onClose: {
      type: Function,
      default: () => {},
    },
    onQuizSelect: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    ...mapState({
      answer: (state) => state.article.answer,
      quizData: (state) => state.article.quizData,
    }),
  },

  data() {
    return {
      OPTION_LABELS: ["A", "B", "C", "D","E", "F", "G", "H"],

      show: true,
    };
  },
  activated() {
    console.log("====>", quizData);
  },
  watch: {},
  methods: {
    onCloseClick() {
      this.onClose();
    },
    formatOptionLabel(index) {
      let answerOpt = this.answer[index].optionId;
      let optionIndex = _.findIndex(this.quizData.questions[index].options, function (
        o
      ) {
        return o.optionId == answerOpt;
      });
      return this.OPTION_LABELS[optionIndex];
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: #00000066;
}

.block {
  position: absolute;
  bottom: 0;
  background-color: #fff;
  height: 70vh;
  width: 100%;
  padding-bottom: 50px;
  border-radius: 20px 20px 0 0;
}

.content-container {
  height: 100%;
  padding: 15px;
  text-align: left;
  overflow: auto;
}

.article-content-title {
  font-size: 18px;
  color: #333333;
  font-family: serif,SimSun,STSong;
  margin: 5px 0;
  word-wrap: break-word;
}

.article-content-snapshot {
  padding-bottom: 10px;
  font-size: 14px;
}

.article-label-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  font-size: 11px;
  color: #999999;
  -webkit-transform-origin-x: 0;
  -webkit-transform: scale(0.9);
}

.text-level-desc {
  margin-top: 10px;
  font-size: 12px;
  transform: scale(0.9);
  color: #333333;
}

.button-close {
  text-align: center;
  margin: 10px;
}

.question-item-container {
  display: flex;
  
}

.question-item-index {
  text-align: center;
  // background: #453228
  width: 50px;
  margin-right: 10px;
  font-size: 16px;
  color: #333333;
  // display : flex
}

.question-item-title {
  flex: 1;
  font-size: 14px;
  line-height: 24px;
  flex-direction: column;
}

.question-option-select {
  width: 50%;
  text-align: center;
  margin: 20px 0;
  line-height: 32px;
  border: 1px solid #3994E7;
  color: #3994E7;
  font-size: 14px;
  border-radius: 16px;
}

.question-option-unselect {
  width: 50%;
  text-align: center;
  margin: 20px 0;
  line-height: 32px;
  border: 1px solid #999999;
  color: #999999;
  font-size: 14px;
  border-radius: 16px;
}
</style>


// WEBPACK FOOTER //
// app/pages/article/component/QuizListModal.vue